var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"btnLabel text-none text-subtitle-1",attrs:{"text":"","rounded":"","block":_vm.$vuetify.breakpoint.smAndDown}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.btnLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }